import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { BehaviorSubject, forkJoin, of, throwError } from 'rxjs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { R } from '@core/utils/r';
import { CompactProposalTableResponse, ProposalsPageQuery, ProposalStatus } from '@business/entities/proposal';
import { switchMap } from 'rxjs/operators';
import { PaginatedController } from '@core/utils/paginated';

export class ProposalsPageBloc extends BaseBloc {
  private readonly proposalBloc = resolve(Blocs.proposal);
  private readonly userBloc = resolve(Blocs.user);
  loading = new LoadingState();
  //   proposals$ = this.proposalBloc.proposals$;
  readonly users$ = this.userBloc.staff$;

  requestId = new BehaviorSubject<number>(1);

  onInit() {
    return this.paginated.reload();
    // return forkJoin(this.proposalBloc.fetchProposals()).pipe(this.loading.run());
  }

  fetchFn = (query: ProposalsPageQuery, extra: string, requestId: () => number) => {
    return this.proposalBloc.fetchProposalsPaginated(query).pipe(
      switchMap(data => {
        if (data.additional!.requestId < requestId()) {
          return throwError('Request Id Mismatch');
        }
        return of(data);
      }),
      this.loading.run({}),
    );
  };

  readonly paginated = new PaginatedController<CompactProposalTableResponse, string, ProposalsPageQuery, { requestId: string; total: number }>(
    this.fetchFn,
    '',
    {
      page: 1,
    },
  );
  readonly proposals$ = this.paginated.items$;

  onReload = () => {
    return this.paginated.reload();
    // return this.proposalBloc.fetchProposals();
  };

  updateStatus = this.proposalBloc.updateStatus;
  updateTitle = this.proposalBloc.updateTitle;
  deleteProposal = this.proposalBloc.deleteProposal;
  unarchiveProposal = this.proposalBloc.unarchiveProposal;
  newDuplicateProposal = this.proposalBloc.newDuplicateProposal;
  hardDeleteProposal = this.proposalBloc.hardDeleteProposal;
  printProposal = this.proposalBloc.printProposal;
}
